<fui-pop-fascia [disabled]="disabled || readonly" (focussed$)="focus()" fui-touch (shortTouch)="click()">
    <fui-fixtures>
        <fui-fixture>
            <fui-checkbox-dom [disabled]="disabled" [readonly]="readonly"
                              [focussed]="focussed" [hovered]="hovered" [valued]="valued">
                <input (blur)="onBlur($event)" [disabled]="disabled || readonly" (focus)="onFocus($event)" #input
                       [name]="name"
                       [(ngModel)]="value" [tabindex]="tabindex" type="checkbox">
            </fui-checkbox-dom>
        </fui-fixture>
        <fui-fixture [wrappable]="true">
            <fui-pop-checkbox-label [disabled]="disabled || readonly" [focussed]="focussed" [hovered]="hovered"
                                    [title]="label" [i18NParams]="labelI18NParams" [valued]="valued"
                                    [allowMarkup]="allowLabelMarkup"></fui-pop-checkbox-label>
        </fui-fixture>
    </fui-fixtures>
</fui-pop-fascia>
